import { Reducer } from 'redux';
import { KnownAction } from './opportunetisActions';
import { ApiOpportunitiesState } from './opportunetisModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ApiOpportunitiesState> = (state: ApiOpportunitiesState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            opportunities: [],
            loading: false
        };
    }

    switch (action.type) {
        case 'SET_OPPORTUNITIES':
            return Object.assign({}, state, { opportunities: action.data });
        case 'SET_LOADING_OPPORTUNITIES':
            return Object.assign({}, state, { loading: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/opportuneties/opportunetisReducers.ts